import React, { useState } from 'react'
import Input from '../../controls/Input';
import { HiMenu } from 'react-icons/hi';
import { useFormik } from 'formik';
import { useToast } from '../../controls/Toast/ToastService';
import * as yup from "yup";
import Container from '../../base/Container';
import { IoCheckmarkDoneCircleOutline } from 'react-icons/io5';
import { MdErrorOutline } from 'react-icons/md';
import { CiLocationArrow1 } from 'react-icons/ci';
import * as applicationUserCrud from "../../../configurations/crud/applicationUserCrud";
import LodingButton from '../../controls/LodingButton';
import Card from '../../controls/Card';
import { TbPasswordFingerprint } from "react-icons/tb";
import { RiLockPasswordFill } from "react-icons/ri";
import useGlobalLoader from '../../../configurations/useGlobalLoader';

const schema = yup.object().shape({
  oldPass: yup
    .string()
    .required("Current Password is required."),

  newPass: yup
    .string()
    .min(8, "Password must have 8 charactors")
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/, {
      message:
        "Password should contains one Capital letter, one small letter, one special charactor and a digit.",
    })
    .required("New password is required."),
  confirmPassword: yup
    .string()
    .oneOf(
      [yup.ref("newPass"), null],
      "New password and Confirm password missmatch"
    )
    .required("Confirm password is required."),
});

export default function ChangePassword() {
  const {start,end} = useGlobalLoader()
  const [loding, setLoding] = useState(false)
  const toast = useToast()
  const {
    values,
    errors,
    isValid,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    setValues,
  } = useFormik({
    initialValues: {

      oldPass: "",
      newPass: "",
      confirmPassword: "",
    },
    validationSchema: schema,
    onSubmit(val) {
      handleChangePassword(val)
    }
  });

  function handleChangePassword(val) {
    setLoding(true)
    start()
    applicationUserCrud.ChangePassword(values).then(res => {
      if (res.data) {
        let data = res.data
        if (data.succeeded) {
          toast.open("Password has been changed successfully.", <IoCheckmarkDoneCircleOutline />, "success")
        } else {
          toast.open(data.message, <MdErrorOutline />, "danger")
        }
      }
      else {
        toast.open("Server Error", <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  return (
    <>
      <Container title={"Change Password"}>
        <div class="w-full md:w-4/12 md:mx-2"></div>
        <div class="w-full md:w-4/12 md:mx-2">
          <Card title={"Change Password"} isBack={true} isBorder={true}>

            <form onSubmit={handleSubmit} className='p-3'>
              <div>
                <label
                  htmlFor="oldPass"
                  className="block text-sm mt-4 font-medium leading-6 text-gray-900"
                >
                  Current Password
                </label>
                <div className="mt-2">
                  <Input
                    type="password"
                    placeholder="Current Password"
                    id="oldPass"
                    Icon={<TbPasswordFingerprint className="text-blue-500 h-6 w-6" />}
                    value={values.oldPass}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isError={errors.oldPass && touched.oldPass} />
                  {errors.oldPass && touched.oldPass && (
                    <p className="text-red-600 text-xs">
                      {errors.oldPass}
                    </p>
                  )}
                </div>
              </div>

              <div>
                <label
                  htmlFor="newPass"
                  className="block text-sm mt-4 font-medium leading-6 text-gray-900"
                >
                  New Password
                </label>
                <div className="mt-2">
                  <Input
                    type="password"
                    placeholder="New Password"
                    id="newPass"
                    Icon={<TbPasswordFingerprint className="text-blue-500 h-6 w-6" />}
                    value={values.newPass}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isError={errors.newPass && touched.newPass} />
                  {errors.newPass && touched.newPass && (
                    <p className="text-red-600 text-xs">
                      {errors.newPass}
                    </p>
                  )}
                </div>
              </div>

              <div>
                <label
                  htmlFor="confirmPassword"
                  className="block text-sm mt-4 font-medium leading-6 text-gray-900"
                >
                  Confirm Password
                </label>
                <div className="mt-2">
                  <Input
                    type="password"
                    placeholder="Confirm Password"
                    id="confirmPassword"
                    Icon={<RiLockPasswordFill className="text-green-500 h-6 w-6" />}
                    value={values.confirmPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isError={errors.confirmPassword && touched.confirmPassword} />
                  {errors.confirmPassword && touched.confirmPassword && (
                    <p className="text-red-600 text-xs">
                      {errors.confirmPassword}
                    </p>
                  )}
                </div>
              </div>
              <div class="mt-4">
                {!loding ?
                  <button type="submit" className={!isValid ? "btn-blue-disabled" : "btn-blue"} disabled={!isValid}>Save</button>
                  : <LodingButton text="Wait.." />
                }
              </div>
            </form>
          </Card>
        </div>
      </Container>
    </>
  );
}